import { StoreModule } from '@/store/store'

export default class AttributeLabelsModule extends StoreModule {
  labels: Record<string, string> = {}
}

export interface AttributeLabel {
  key: string;
  value: string;
}
